export default __webpack_public_path__ + "static/media/note-image.4e484b06.png";